$(document).ready(function() {
  // Set default first thumbnail content to main image section
  let $firstThumb = $(".thumb-wrap").first();
  updateMainContent($firstThumb);
  
  $('.product-thumb').slick({
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='//47jewelry.com/cdn/shop/t/33/assets/arrow-up.svg?v=113558664497800756321744287426'>",
    nextArrow:"<img class='a-left control-c prev slick-prev' src='//47jewelry.com/cdn/shop/t/33/assets/arrow-down.svg?v=10467475907529935331744287426'>",
    responsive: [{
      breakpoint: 769,
      settings:{
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }]
  });
    
  // Click event for thumbnails  
  $(document).on("click", ".thumb-wrap", function() {
      updateMainContent($(this));
  
      $(".thumb-wrap").removeClass("active");
      $(this).addClass("active");
  });
});
function updateMainContent($element) {
  let $content = $element.children().clone(); // Clone the inner element (img or video)
  if ($content.is("video")) {
    //$content.attr("controls", true); // Add controls if it's a video
    //$content.attr("poster", "images/2J459-3_700x.jpg")
    $content.attr("autoplay", true); // Add autoplay if it's a video
    // $content.attr("loop", true); // Add loops if it's a video
    // $content.attr("muted", true); // Add mute if it's a video
    // $content.attr("playsinline", true); // Add mute if it's a video
    // $content.attr("preload", "metadata"); // Add mute if it's a video
  }
  $(".main-img-wrap").html($content); // Update main display
  if ($content.is("video")) {
    let video = document.querySelector(".main-img-wrap video");
    if (video) {
        video.muted = true;
        video.play().catch(error => console.log("Autoplay blocked:", error));
    }
  }
}